<template>
  <div>
    <div class="l-container">
      <router-view :contract="contract"></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  computed: {
    contract () {
      return this.$store.getters.contract
    }
  },
  methods: {
    getContract (id) {
      this.$store.dispatch('getContract', id)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getContract(to.params.id)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Contract.vue?4390057c